/** Style binding for `.mask-icon`. Quoted, because Vite inlines small SVGs as data: URIs. */
export function maskIcon(url: string): Record<string, string> {
  return { '--icon': `url(${JSON.stringify(url)})` };
}
